module.exports = __webpack_public_path__ + "static/media/mic-speaking3.a635ba2a.svg";